import { render } from "./Toolbar.vue?vue&type=template&id=2261f4f9&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=2261f4f9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2261f4f9"

export default script